/** @domain exerciseWindowConfig -- SAR exercise window configuration fields. */
import { z } from 'zod';
import { createDomainField } from './types';

const define = createDomainField('exerciseWindowConfig');

export const windowName = define({
  label: 'Window Name',
  placeholder: 'Enter window name',
  schema: z.string().max(256),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const isActive = define({
  label: 'Window Configuration Active',
  schema: z.boolean(),
  adapterHint: 'select',
  displayFormat: 'boolean',
});

export const allowPartialExercise = define({
  label: 'Allow Partial Exercise',
  schema: z.boolean(),
  adapterHint: 'checkbox',
  displayFormat: 'boolean',
});

export const creationTime = define({
  label: 'Created',
  schema: z.string(),
  adapterHint: 'date',
  displayFormat: 'date',
});
